import axios from "axios";
import axiosRetry from "axios-retry";

const RETRIES = 5;
let saveDelay = 1;
const api = {
	init: function (store) {

		// INTERCEPTEUR DE REQUETE (avant l'appel)
		axios.interceptors.request.use(function (config) {
			// On ajoute le token uniquement si c'est une requête vers l'api adequation
			if (config.url.startsWith(process.env.VUE_APP_API_BASE_URL)) {
				config.headers["Authorization"] = "Bearer " + store.getters.user.token;
			}
			store.dispatch("set_loading", { loading: true });
			return config;
		}, function (error) {
			return Promise.reject(error);
		});

		// INTERCEPTEUR DE REPONSE (après l'appel)
		axios.interceptors.response.use(function (response) {
			store.dispatch("set_loading", { loading: false });
			if (response.config.url.startsWith(process.env.VUE_APP_API_BASE_URL) ){
				saveDelay = 1;
				// force green "floppy disk"
				if(store.state.study.saving && store.state.study.last_save_failed){
					store.dispatch("set_last_save_failed", { last_save_failed: false });
				}
				if(store.state.study.offline){
					store.dispatch("set_offline", { offline: false });
				}
			}
			return response;
		},async function (error) {
			const response = error.response;
			if(
				response
				&& response.config
				&& response.config.url.startsWith(process.env.VUE_APP_API_BASE_URL)
				&& response.status === 401
			){
				store.dispatch("logout",{token_expiry:true});
			}
			else if (response && response.status == 422) {
				store.dispatch('add_notification', {status: 'error', message: response.data.message});
			}

			if(store.state.study.saving){
				store.dispatch("set_offline", { offline: true });
				store.dispatch("set_last_save_failed", { last_save_failed: true });
				if (response.data.message) store.dispatch("add_notification", { status: "error", message: response.data.message });
				else store.dispatch("add_notification", { status: "error", message: "Oups ! Une erreur est survenue. Format de réponse invalide." });
			}
			if(!error.response){
				if(axios.isCancel(error)){
					return Promise.reject("cancelled");
				}
				else{
					alert("Perte de connexion.\nVoulez-vous tester votre connexion ?");
					await isOnline(error.config);
				}
			}
			return Promise.reject(error);
		});

		// RETRY (sauf dans le cas d'une mauvaise authentification ou d'une publication)

		axiosRetry(axios, {
			retries: RETRIES,
			retryDelay: (retryCount) => {
				if(retryCount >= RETRIES ) {
					store.dispatch("set_loading", { loading: false });
					if(store.state.study.last_save_failed){
						alert("Impossible de sauvegarder.\nVoulez-vous réessayer ?");
						saveDelay = 0; // set retry time to 0 millisecond
					}
					else{
						store.dispatch("add_notification", { status: "error", message: "Oups ! Impossible de se connecter au serveur." });
					}
				}
				return retryCount * 500 * saveDelay;
			},
			retryCondition: function (error) {
				return (
					error.response !== undefined
					&&
					!(error.response.status === 401 && error.response.config.url.startsWith(process.env.VUE_APP_API_BASE_URL))
					&&
					!error.response.config.url.toLowerCase().includes("api/login")
					&&
					!error.response.config.url.toLowerCase().includes("api/evalis/api/check-code-evalis")
					&&
					!error.response.config.url.toLowerCase().includes("api/etude/publish")
					&&
					!axios.isCancel(error)
				);
			},
		});

		async function isOnline (config) {
			const response = await axios.request(config);
			console.info(response);
			if(response.status == "200"){
				alert("Vous avez retrouvé la connexion.");
				if(store.state.study.saving){
					store.dispatch("set_offline", { offline: false });
					store.dispatch("set_saving", {saving: false});
					store.dispatch("set_required", {required: true});
				}
			}
		}
	}
};


export default api;